var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row mb-5"},[_c('v-btn',{attrs:{"outlined":"","color":"secondary","small":""},on:{"click":_vm.createSample}},[_vm._v("Create")]),_c('v-spacer'),_c('YearSelector',{on:{"select":_vm.load}})],1),_c('List',{on:{"edit":_vm.handleEdit}}),_c('Form',{ref:"form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }